import { WbAlert } from '@agilelab/plugin-wb-platform';
import { ErrorListProps } from '@rjsf/utils';

export const ErrorListTemplate = ({ errors }: ErrorListProps) => {
  if (errors.length === 0) return null;

  return (
    <WbAlert
      style={{ marginTop: 16, marginBottom: 16 }}
      message={{
        type: 'error',
        title: 'Form Errors',
        content: (
          <>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              {errors.map((error, i) => (
                <li key={i}>{error.message}</li>
              ))}
            </ul>
            <p style={{ marginTop: 8, marginBottom: 0 }}>
              Please contact the platform team for assistance.
            </p>
          </>
        ),
      }}
    />
  );
};
